import { LocalLoader } from "modules/common/components/loader/Loader";
import React from "react";
import styles from "./ReturnList.module.scss";

import { observer } from "mobx-react";
import { EmployerName } from "modules/common/components/employer/EmployerName";
import { formatMoney } from "modules/common/components/money/Money";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import InfiniteScroll from "react-infinite-scroller";
import { ImportSpendingsStoreType } from "../models/import-store";
import { ReturnListStoreType } from "../models/return-list";
class ReturnItems extends React.Component<ReturnListProps> {
  scroller = React.createRef<HTMLDivElement>();

  async componentDidMount() {
    await this.props.store.load();
  }
  getScrollParent = () => this.scroller.current;
  render() {
    const { store } = this.props;
    return (
      <div className={`${styles.wrapper} `}>
        {store.loading ? (
          <div>
            <LocalLoader active={store.loading} />
          </div>
        ) : (
          <>
            <div className={styles.mainRow}>
              <div className={styles.date}>Дата</div>
              <div className={styles.sum}>Сумма</div>
              <div className={styles.payer}>Плательщик</div>
              <div className={styles.recipient}>Получатель</div>
              <div className={styles.description}>Назначение</div>
              <div className={styles.button}></div>
            </div>
            <div className={styles.scroller} ref={this.scroller}>
              {store.rows && store.rows.length > 0 && (
                <InfiniteScroll
                  pageStart={1}
                  loadMore={() => {
                    store.loadNext();
                  }}
                  hasMore={store.hasMore}
                  useWindow={false}
                  initialLoad={false}
                  threshold={100}
                  getScrollParent={this.getScrollParent}
                >
                  {store.rows.map((row) => (
                    <div className={styles.mainRow} key={row.id}>
                      <div className={styles.date}>{row.date}</div>
                      <div className={styles.sum}>{formatMoney(row.sum)}</div>
                      <div className={styles.payer}>
                        <EmployerName
                          showTitle={row.cleanPayer.length > 30}
                          name={row.cleanPayer}
                          position={`РС: ${row.payerBankDetails.account}`}
                        />
                      </div>
                      <div className={styles.recipient}>
                        <EmployerName
                          showTitle={row.cleanRecipient.length > 30}
                          name={row.cleanRecipient}
                          position={`РС: ${row.recipientBankDetails.account}`}
                        />
                      </div>
                      <div className={styles.description}>{row.description}</div>
                      {/* <div className={styles.isIncoimng}>
                        {row.incoimng && <GeneralIcon type="general-check" style={{ color: "#1DD278" }} />}
                      </div> */}
                      <div className={styles.button}>
                        <PlanrButton
                          size="small"
                          type="greenish"
                          onClick={async () => {
                            const res = await store.returnPayment(row.id);
                            if (res) {
                              this.props.setReturned();
                            }
                          }}
                        >
                          Вернуть
                        </PlanrButton>
                      </div>
                    </div>
                  ))}
                </InfiniteScroll>
              )}
            </div>
          </>
        )}
      </div>
    );
  }
}

export const ReturnList = observer(ReturnItems);

interface ReturnListProps {
  store: ReturnListStoreType;
  import: ImportSpendingsStoreType;
  setReturned: () => void;
}

interface ReturnListState {
  copied: boolean;
}
